<template>
  <article ref="scrollBox" class="bus_list_wrap home">
    <!-- <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">酒店</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>-->
    <section class="pages_content">

      <div class="hDetail">
        <div class="hDetailTopImg" :style="{backgroundImage:`url(${bg})`}">
          <div class="backDiv">
            <div class="backIcon" @click="$router.go(-1);">
              <i class="iconfont_new icon-Left"></i>
            </div>
          </div>
          <div class="hDetailName">上海万信R酒店</div>
          <div class="titleIcon">
            <i class="iconfont_new icon-zhuanshi1 zuanshi"></i>
            <i class="iconfont_new icon-zhuanshi1 zuanshi"></i>
            <i class="iconfont_new icon-zhuanshi1 zuanshi"></i>
            <i class="iconfont_new icon-zhuanshi1 zuanshi"></i>
            <i class="iconfont_new icon-zhuanshi1 zuanshi"></i>
          </div>
        </div>
        <div class="positionInfoBox">
          <div class="flexContainer positionInfoItem">
            <div class="flexItem1">
              <div class="text1">川沙路5919号</div>
              <div class="text2"><i class="iconfont_new icon-busdaba"></i>&nbsp;距离安亭北站75.7公里，驾车约69分钟</div>
            </div>
            <div class="text3">
              <i class="iconfont_new icon-dingwei3 blue2Color"></i>
            </div>
          </div>
          <div class="flexContainer positionInfoItem">
            <div class="flexItem1">
              <div class="text1">2020年开业</div>
              <div class="text2">
                <i class="iconfont_new icon-ruzhu1 text4"></i>&nbsp;快速办理入住&nbsp;&nbsp;
                <i class="iconfont_new icon-canting text4"></i>&nbsp;中餐厅&nbsp;&nbsp;
              </div>
            </div>
            <div class="text3">
              <i class="iconfont_new icon-jiudian1 blue2Color"></i>
            </div>
          </div>
        </div>
        <div class="selectDate flexContainer">
          <div class="selectDateShow flexItem1 textalignM">
            <div class="selectDateShowTitle">入住<span class="selectDateShowCon bolderFont1">08-18</span></div>
          </div>
          <div>
            <div class="selectDateM textalignM">
              1晚
            </div>
          </div>
          <div class="selectDateShow flexItem1 textalignM">
            <div class="selectDateShowTitle">离店<span class="selectDateShowCon bolderFont1">08-20</span></div>
          </div>
        </div>


        <Spin v-if="loading">
          <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
          <div class="colorprimary">加载中</div>
        </Spin>

        <div style="padding:0.3rem 0.3rem;">
          <good-item2 :list="list" detailPage="HotelDetail" @showModal="showModal"></good-item2>
        </div>


        <Modal v-model="detailModal" class-name="myModalNoFooter" :closable="false" >

          <div style="position:relative;">
            <swiper
              :swiperImgArray="advertList"
              :swiperWrapClass="swiperClass"
              style="position:relative;z-index:1;"
            ></swiper>
            <i class="iconfont_new icon-LC_icon_close_circle_line closeIcon" @click="detailModal = false"></i>
          </div>

          <div style="padding:0.2rem 0.3rem;">
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
            支付担保金，提前锁定房源。到店需另付房费，担保金于入住离店后3日内退还。<br>
          </div>
          

          <div slot="footer">
            <div class="flexContainer myFooter">
              <div class="flexItem1">
                <div class="myFooterPrice textalignL">
                  <span class="myFooterPriceIcon">¥</span>350
                </div>
              </div>
              <div class="myFooterBtnDiv">
                <div class="myFooterBtn myFooterBtn2" @click="goNextPage()">订</div>
              </div>
            </div>
          </div>
        </Modal>

        <!-- <Modal v-model="orderModal" class-name="myModalNoFooter" :closable="false" >

          <div :style="{backgroundImage:`url(${bg})`}" class="orderModalImg">
            <i class="iconfont_new icon-LC_icon_close_circle_line closeIcon" @click="orderModal = false" />
          </div>

          <div style="padding:0.2rem 0.3rem;" class="carCheck">
            <div class="carTitle">
              房型：
            </div>
            <RadioGroup v-model="button1" type="button" style="margin-bottom:0.3rem;">
                <Radio label="大床房"></Radio>
                <Radio label="小床房"></Radio>
                <Radio label="迷你床房"></Radio>
                <Radio label="双床"></Radio>
            </RadioGroup>

            <div class="carTitle">入住时间：</div>
            <div class="carInput">2020-05-05</div>

            <div class="carTitle">离店时间：</div>
            <div class="carInput">2020-05-05</div>

            
          </div>

          <div slot="footer">
            <div class="flexContainer myFooter">
              <div class="flexItem1">
                <div class="myFooterPrice textalignL">
                  <span class="myFooterPriceIcon">¥</span>350
                </div>
              </div>
              <div class="myFooterBtnDiv">
                <div class="myFooterBtn myFooterBtn2" @click="goNextPage()">下一步</div>
              </div>
            </div>
          </div>
        </Modal> -->

        


      </div>
    </section>
  </article>
</template>

<script>
import Swiper from "@/components/child-components/Swiper";
import goodItem2 from "@/components/child-components/goodItem2";
export default {
  name: "HotelDetail",
  data() {
    return {
      name: "", // 商户标识
      loading: false,
      bg:'https://dimg04.c-ctrip.com/images//20090u000000iva619BE2_C_550_412_Q50.jpg_.webp?v=1',

      advertList: ['https://dimg04.c-ctrip.com/images//200s0u000000j0f155AFB_C_750_400_Q50.jpg_.webp','https://dimg04.c-ctrip.com/images//200s0u000000j0f155AFB_C_750_400_Q50.jpg_.webp'],
      swiperClass: "big_banner_wrap",
      detailModal: false,
      orderModal:false,

      orderData:{},

      list: [
        {
          id: 1,
          name: "豪华大床房",
          position: "大床 55-60 有窗 可吸烟",
          tag: [{ id: 1, value: "闪住" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 2,
          name: "豪华大床房",
          position: "大床 55-60 有窗 可吸烟",
          tag: [{ id: 1, value: "闪住" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 3,
          name: "豪华大床房",
          position: "大床 55-60 有窗 可吸烟",
          tag: [{ id: 1, value: "闪住" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 4,
          name: "豪华大床房",
          position: "大床 55-60 有窗 可吸烟",
          tag: [{ id: 1, value: "闪住" }],
          price: 158,
          warning: "低价房即将售完",
        },
      ],
    };
  },
  components: {
    goodItem2: goodItem2,
    swiper: Swiper,
  },
  activated: function () {
    
  },
  created() {},
  mounted() {},
  methods: {
    showModal(key,data){
      if(key == 1){
        this.detailModal = true;
      }
      if(key == 2){
        // this.orderModal = true;
        // this.orderData = data;
        this.$router.push({
          name: "HotelOrderComfirm"
        });
      }
    }
    // goHotelDetail(data){
    //   let that = this;
    //   this.$router.push({
    //     name: "hoteldetail",
    //     params: {
    //       name: that.name,
    //     },
    //   });
    // }
  },
};
</script>

<style scoped lang="less">
@import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HotelDetail.vue